import en_adCarousel from "./locales/en/adCarousel.json";
import en_addressFormModal from "./locales/en/addressFormModal.json";
import en_addresses from "./locales/en/addresses.json";
import en_boDashboard from "./locales/en/boDashboard.json";
import en_boLayout from "./locales/en/boLayout.json";
import en_boLogin from "./locales/en/boLogin.json";
import en_boMessages from "./locales/en/boMessages.json";
import en_boOrderLabel from "./locales/en/boOrderLabel.json";
import en_boOrders from "./locales/en/boOrders.json";
import en_boProducts from "./locales/en/boProducts.json";
import en_boSettings from "./locales/en/boSettings.json";
import en_boShared from "./locales/en/boShared.json";
import en_boSidebar from "./locales/en/boSidebar.json";
import en_boStoreCarousel from "./locales/en/boStoreCarousel.json";
import en_boStoreLayoutDesigner from "./locales/en/boStoreLayoutDesigner.json";
import en_boStoreProfile from "./locales/en/boStoreProfile.json";
import en_boStores from "./locales/en/boStores.json";
import en_cart from "./locales/en/cart.json";
import en_categoryMegaMenu from "./locales/en/categoryMegaMenu.json";
import en_checkout from "./locales/en/checkout.json";
import en_clientLoginModal from "./locales/en/clientLoginModal.json";
import en_common from "./locales/en/common.json";
import en_customServiceModal from "./locales/en/customServiceModal.json";
import en_followedStores from "./locales/en/followedStores.json";
import en_footer from "./locales/en/footer.json";
import en_aboutUs from "./locales/en/aboutUs.json";
import en_join from "./locales/en/join.json";
import en_header from "./locales/en/header.json";
import en_mainPage from "./locales/en/mainPage.json";
import en_messages from "./locales/en/messages.json";
import en_myCoupons from "./locales/en/myCoupons.json";
import en_notifications from "./locales/en/notifications.json";
import en_orders from "./locales/en/orders.json";
import en_productCard from "./locales/en/productCard.json";
import en_productDetails from "./locales/en/productDetails.json";
import en_productsList from "./locales/en/productsList.json";
import en_scrollToTopButton from "./locales/en/scrollToTopButton.json";
import en_storeCard from "./locales/en/storeCard.json";
import en_storeCategoryChips from "./locales/en/storeCategoryChips.json";
import en_storeHeader from "./locales/en/storeHeader.json";
import en_storeNotifications from "./locales/en/storeNotifications.json";
import en_storesList from "./locales/en/storesList.json";
import en_supportButton from "./locales/en/supportButton.json";
import en_supportChatModal from "./locales/en/supportChatModal.json";
import en_wishlist from "./locales/en/wishlist.json";
import en_dcDashboard from "./locales/en/dcDashboard.json";
import en_dcDriverAccess from "./locales/en/dcDriverAccess.json";
import en_dcDrivers from "./locales/en/dcDrivers.json";
import en_dcFees from "./locales/en/dcFees.json";
import en_dcLayout from "./locales/en/dcLayout.json";
import en_dcLogin from "./locales/en/dcLogin.json";
import en_dcOrders from "./locales/en/dcOrders.json";
import en_dcSettings from "./locales/en/dcSettings.json";
import en_dcShared from "./locales/en/dcShared.json";
import en_dcStoreFees from "./locales/en/dcStoreFees.json";

import ar_adCarousel from "./locales/ar/adCarousel.json";
import ar_addressFormModal from "./locales/ar/addressFormModal.json";
import ar_addresses from "./locales/ar/addresses.json";
import ar_boDashboard from "./locales/ar/boDashboard.json";
import ar_boLayout from "./locales/ar/boLayout.json";
import ar_boLogin from "./locales/ar/boLogin.json";
import ar_boMessages from "./locales/ar/boMessages.json";
import ar_boOrderLabel from "./locales/ar/boOrderLabel.json";
import ar_boOrders from "./locales/ar/boOrders.json";
import ar_boProducts from "./locales/ar/boProducts.json";
import ar_boSettings from "./locales/ar/boSettings.json";
import ar_boShared from "./locales/ar/boShared.json";
import ar_boSidebar from "./locales/ar/boSidebar.json";
import ar_boStoreCarousel from "./locales/ar/boStoreCarousel.json";
import ar_boStoreLayoutDesigner from "./locales/ar/boStoreLayoutDesigner.json";
import ar_boStoreProfile from "./locales/ar/boStoreProfile.json";
import ar_boStores from "./locales/ar/boStores.json";
import ar_cart from "./locales/ar/cart.json";
import ar_categoryMegaMenu from "./locales/ar/categoryMegaMenu.json";
import ar_checkout from "./locales/ar/checkout.json";
import ar_clientLoginModal from "./locales/ar/clientLoginModal.json";
import ar_common from "./locales/ar/common.json";
import ar_customServiceModal from "./locales/ar/customServiceModal.json";
import ar_followedStores from "./locales/ar/followedStores.json";
import ar_footer from "./locales/ar/footer.json";
import ar_aboutUs from "./locales/ar/aboutUs.json";
import ar_join from "./locales/ar/join.json";
import ar_header from "./locales/ar/header.json";
import ar_mainPage from "./locales/ar/mainPage.json";
import ar_messages from "./locales/ar/messages.json";
import ar_myCoupons from "./locales/ar/myCoupons.json";
import ar_notifications from "./locales/ar/notifications.json";
import ar_orders from "./locales/ar/orders.json";
import ar_productCard from "./locales/ar/productCard.json";
import ar_productDetails from "./locales/ar/productDetails.json";
import ar_productsList from "./locales/ar/productsList.json";
import ar_scrollToTopButton from "./locales/ar/scrollToTopButton.json";
import ar_storeCard from "./locales/ar/storeCard.json";
import ar_storeCategoryChips from "./locales/ar/storeCategoryChips.json";
import ar_storeHeader from "./locales/ar/storeHeader.json";
import ar_storeNotifications from "./locales/ar/storeNotifications.json";
import ar_storesList from "./locales/ar/storesList.json";
import ar_supportButton from "./locales/ar/supportButton.json";
import ar_supportChatModal from "./locales/ar/supportChatModal.json";
import ar_wishlist from "./locales/ar/wishlist.json";
import ar_dcDashboard from "./locales/ar/dcDashboard.json";
import ar_dcDriverAccess from "./locales/ar/dcDriverAccess.json";
import ar_dcDrivers from "./locales/ar/dcDrivers.json";
import ar_dcFees from "./locales/ar/dcFees.json";
import ar_dcLayout from "./locales/ar/dcLayout.json";
import ar_dcLogin from "./locales/ar/dcLogin.json";
import ar_dcOrders from "./locales/ar/dcOrders.json";
import ar_dcSettings from "./locales/ar/dcSettings.json";
import ar_dcShared from "./locales/ar/dcShared.json";
import ar_dcStoreFees from "./locales/ar/dcStoreFees.json";

import he_adCarousel from "./locales/he/adCarousel.json";
import he_addressFormModal from "./locales/he/addressFormModal.json";
import he_addresses from "./locales/he/addresses.json";
import he_boDashboard from "./locales/he/boDashboard.json";
import he_boLayout from "./locales/he/boLayout.json";
import he_boLogin from "./locales/he/boLogin.json";
import he_boMessages from "./locales/he/boMessages.json";
import he_boOrderLabel from "./locales/he/boOrderLabel.json";
import he_boOrders from "./locales/he/boOrders.json";
import he_boProducts from "./locales/he/boProducts.json";
import he_boSettings from "./locales/he/boSettings.json";
import he_boShared from "./locales/he/boShared.json";
import he_boSidebar from "./locales/he/boSidebar.json";
import he_boStoreCarousel from "./locales/he/boStoreCarousel.json";
import he_boStoreLayoutDesigner from "./locales/he/boStoreLayoutDesigner.json";
import he_boStoreProfile from "./locales/he/boStoreProfile.json";
import he_boStores from "./locales/he/boStores.json";
import he_cart from "./locales/he/cart.json";
import he_categoryMegaMenu from "./locales/he/categoryMegaMenu.json";
import he_checkout from "./locales/he/checkout.json";
import he_clientLoginModal from "./locales/he/clientLoginModal.json";
import he_common from "./locales/he/common.json";
import he_customServiceModal from "./locales/he/customServiceModal.json";
import he_followedStores from "./locales/he/followedStores.json";
import he_footer from "./locales/he/footer.json";
import he_aboutUs from "./locales/he/aboutUs.json";
import he_join from "./locales/he/join.json";
import he_header from "./locales/he/header.json";
import he_mainPage from "./locales/he/mainPage.json";
import he_messages from "./locales/he/messages.json";
import he_myCoupons from "./locales/he/myCoupons.json";
import he_notifications from "./locales/he/notifications.json";
import he_orders from "./locales/he/orders.json";
import he_productCard from "./locales/he/productCard.json";
import he_productDetails from "./locales/he/productDetails.json";
import he_productsList from "./locales/he/productsList.json";
import he_scrollToTopButton from "./locales/he/scrollToTopButton.json";
import he_storeCard from "./locales/he/storeCard.json";
import he_storeCategoryChips from "./locales/he/storeCategoryChips.json";
import he_storeHeader from "./locales/he/storeHeader.json";
import he_storeNotifications from "./locales/he/storeNotifications.json";
import he_storesList from "./locales/he/storesList.json";
import he_supportButton from "./locales/he/supportButton.json";
import he_supportChatModal from "./locales/he/supportChatModal.json";
import he_wishlist from "./locales/he/wishlist.json";
import he_dcDashboard from "./locales/he/dcDashboard.json";
import he_dcDriverAccess from "./locales/he/dcDriverAccess.json";
import he_dcDrivers from "./locales/he/dcDrivers.json";
import he_dcFees from "./locales/he/dcFees.json";
import he_dcLayout from "./locales/he/dcLayout.json";
import he_dcLogin from "./locales/he/dcLogin.json";
import he_dcOrders from "./locales/he/dcOrders.json";
import he_dcSettings from "./locales/he/dcSettings.json";
import he_dcShared from "./locales/he/dcShared.json";
import he_dcStoreFees from "./locales/he/dcStoreFees.json";

const resources = {
  en: {
    dcDashboard: en_dcDashboard,
    dcDriverAccess: en_dcDriverAccess,
    dcDrivers: en_dcDrivers,
    dcFees: en_dcFees,
    dcLayout: en_dcLayout,
    dcLogin: en_dcLogin,
    dcOrders: en_dcOrders,
    dcSettings: en_dcSettings,
    dcShared: en_dcShared,
    dcStoreFees: en_dcStoreFees,
    adCarousel: en_adCarousel,
    addressFormModal: en_addressFormModal,
    addresses: en_addresses,
    boDashboard: en_boDashboard,
    boLayout: en_boLayout,
    boLogin: en_boLogin,
    boMessages: en_boMessages,
    boOrderLabel: en_boOrderLabel,
    boOrders: en_boOrders,
    boProducts: en_boProducts,
    boSettings: en_boSettings,
    boShared: en_boShared,
    boSidebar: en_boSidebar,
    boStoreCarousel: en_boStoreCarousel,
    boStoreLayoutDesigner: en_boStoreLayoutDesigner,
    boStoreProfile: en_boStoreProfile,
    boStores: en_boStores,
    cart: en_cart,
    categoryMegaMenu: en_categoryMegaMenu,
    checkout: en_checkout,
    clientLoginModal: en_clientLoginModal,
    common: en_common,
    customServiceModal: en_customServiceModal,
    followedStores: en_followedStores,
    footer: en_footer,
    aboutUs: en_aboutUs,
    join: en_join,
    header: en_header,
    mainPage: en_mainPage,
    messages: en_messages,
    myCoupons: en_myCoupons,
    notifications: en_notifications,
    orders: en_orders,
    productCard: en_productCard,
    productDetails: en_productDetails,
    productsList: en_productsList,
    scrollToTopButton: en_scrollToTopButton,
    storeCard: en_storeCard,
    storeCategoryChips: en_storeCategoryChips,
    storeHeader: en_storeHeader,
    storeNotifications: en_storeNotifications,
    storesList: en_storesList,
    supportButton: en_supportButton,
    supportChatModal: en_supportChatModal,
    wishlist: en_wishlist,
  },
  ar: {
    dcDashboard: ar_dcDashboard,
    dcDriverAccess: ar_dcDriverAccess,
    dcDrivers: ar_dcDrivers,
    dcFees: ar_dcFees,
    dcLayout: ar_dcLayout,
    dcLogin: ar_dcLogin,
    dcOrders: ar_dcOrders,
    dcSettings: ar_dcSettings,
    dcShared: ar_dcShared,
    dcStoreFees: ar_dcStoreFees,
    adCarousel: ar_adCarousel,
    addressFormModal: ar_addressFormModal,
    addresses: ar_addresses,
    boDashboard: ar_boDashboard,
    boLayout: ar_boLayout,
    boLogin: ar_boLogin,
    boMessages: ar_boMessages,
    boOrderLabel: ar_boOrderLabel,
    boOrders: ar_boOrders,
    boProducts: ar_boProducts,
    boSettings: ar_boSettings,
    boShared: ar_boShared,
    boSidebar: ar_boSidebar,
    boStoreCarousel: ar_boStoreCarousel,
    boStoreLayoutDesigner: ar_boStoreLayoutDesigner,
    boStoreProfile: ar_boStoreProfile,
    boStores: ar_boStores,
    cart: ar_cart,
    categoryMegaMenu: ar_categoryMegaMenu,
    checkout: ar_checkout,
    clientLoginModal: ar_clientLoginModal,
    common: ar_common,
    customServiceModal: ar_customServiceModal,
    followedStores: ar_followedStores,
    footer: ar_footer,
    aboutUs: ar_aboutUs,
    join: ar_join,
    header: ar_header,
    mainPage: ar_mainPage,
    messages: ar_messages,
    myCoupons: ar_myCoupons,
    notifications: ar_notifications,
    orders: ar_orders,
    productCard: ar_productCard,
    productDetails: ar_productDetails,
    productsList: ar_productsList,
    scrollToTopButton: ar_scrollToTopButton,
    storeCard: ar_storeCard,
    storeCategoryChips: ar_storeCategoryChips,
    storeHeader: ar_storeHeader,
    storeNotifications: ar_storeNotifications,
    storesList: ar_storesList,
    supportButton: ar_supportButton,
    supportChatModal: ar_supportChatModal,
    wishlist: ar_wishlist,
  },
  he: {
    dcDashboard: he_dcDashboard,
    dcDriverAccess: he_dcDriverAccess,
    dcDrivers: he_dcDrivers,
    dcFees: he_dcFees,
    dcLayout: he_dcLayout,
    dcLogin: he_dcLogin,
    dcOrders: he_dcOrders,
    dcSettings: he_dcSettings,
    dcShared: he_dcShared,
    dcStoreFees: he_dcStoreFees,
    adCarousel: he_adCarousel,
    addressFormModal: he_addressFormModal,
    addresses: he_addresses,
    boDashboard: he_boDashboard,
    boLayout: he_boLayout,
    boLogin: he_boLogin,
    boMessages: he_boMessages,
    boOrderLabel: he_boOrderLabel,
    boOrders: he_boOrders,
    boProducts: he_boProducts,
    boSettings: he_boSettings,
    boShared: he_boShared,
    boSidebar: he_boSidebar,
    boStoreCarousel: he_boStoreCarousel,
    boStoreLayoutDesigner: he_boStoreLayoutDesigner,
    boStoreProfile: he_boStoreProfile,
    boStores: he_boStores,
    cart: he_cart,
    categoryMegaMenu: he_categoryMegaMenu,
    checkout: he_checkout,
    clientLoginModal: he_clientLoginModal,
    common: he_common,
    customServiceModal: he_customServiceModal,
    followedStores: he_followedStores,
    footer: he_footer,
    aboutUs: he_aboutUs,
    join: he_join,
    header: he_header,
    mainPage: he_mainPage,
    messages: he_messages,
    myCoupons: he_myCoupons,
    notifications: he_notifications,
    orders: he_orders,
    productCard: he_productCard,
    productDetails: he_productDetails,
    productsList: he_productsList,
    scrollToTopButton: he_scrollToTopButton,
    storeCard: he_storeCard,
    storeCategoryChips: he_storeCategoryChips,
    storeHeader: he_storeHeader,
    storeNotifications: he_storeNotifications,
    storesList: he_storesList,
    supportButton: he_supportButton,
    supportChatModal: he_supportChatModal,
    wishlist: he_wishlist,
  },
};

export default resources;
